import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseBoardSearch } from "@/features/orders";
import { OrdersPage } from "@/features/orders/pages";
import { strictSearch } from "@/shared/lib/search";

export const Route = createFileRoute("/_app/orders/")({
  validateSearch: strictSearch(parseBoardSearch),
  component: Board,
});

function Board() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <OrdersPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(next) => router.buildLocation({ to: "/orders", search: next }).href}
    />
  );
}
